import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useTranslation } from 'react-i18next';

const ConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  cancelButtonName = 'Cancel',
  submitButtonName = 'Submit',
  loading = false,
}) => {
  const { t: translate } = useTranslation();
  cancelButtonName = cancelButtonName === 'Cancel' ? translate('common.cancel') : cancelButtonName;
  submitButtonName = submitButtonName === 'Submit' ? translate('common.submit') : submitButtonName;
  return (
    <Dialog open={open} onClose={() => onClose()}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={() => onClose()}>
          {cancelButtonName}
        </Button>
        {submitButtonName && (
          loading ? (
            <LoadingButton variant="contained" loading={loading} autoFocus>
              {submitButtonName}
            </LoadingButton>
          ) : (
            <Button
              variant="contained"
              onClick={() => {
                onConfirm();
              }}
              autoFocus
            >
              {submitButtonName}
            </Button>
          )
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
